import React from "react";
export default class CustomTextArea extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            value:(this.props.value)?this.props.value:"",
            errorClass:""
        }

    }
    onChangeHandler(event){
        this.setState({value: event.target.value});
    }
    render() {
        return (
            <div className="custom-text-area">
                <label for={this.props.customRef}  >{this.props.label}</label>

                <textarea
                    ref= {this.props.customRef}
                    placeholder= {this.props.placeholder}
                    onChange={this.onChangeHandler.bind(this)}
                    value = {this.state.value}
                    required = {this.props.required}
                />

            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/app/common/components/CustomTextArea.jsx